import moment from 'moment-timezone';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { deleteCoursesAndTraining, getListCoursesAndTraining } from '../app/store/actions/coursesAndTraining';
import ModalComponent from '../components/modal';
import Table from '../components/table/table';
import ROUTES from '../data/routes';
import { history } from '../routers/AppRouter';

class CoursesAndTrainingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      search: '',
      orderBy: 'DESC',
      field: 'createdAt',
      dataList: [],
      totalRecord: 0,
      showModal: false,
      showCancel: false,
      titleModal: '',
      titleModalBody: '',
      selectedLine: {},
    };

    this.tableHeader = [
      { key: 'id', value: I18n.t('id') },
      { key: 'line', value: I18n.t('line') },
      { key: 'category', value: I18n.t('category') },
      { key: 'name', value: I18n.t('courseName') },
      { key: 'certificate', value: I18n.t('certificate') },
      { key: 'courseDate', value: I18n.t('date') },
      { key: 'courseTime', value: I18n.t('Hour') },
      { key: 'action', value: I18n.t('action') },
    ];
  }

  componentDidMount() {
    this.getListCoursesAndTraining();
  }

  adjustData = async (count = 0, rows = []) => {
    const dataList = rows.map(element => ({
      key: element.id,
      id: element.id,
      line: element.line,
      category: element.category,
      name: element.name,
      certificate: element.certificate,
      courseDate: moment(element.courseDate).format('DD-MM-YYYY'),
      courseTime: element.courseTime,
      action: (
        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {I18n.t('action')}
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => {
                  history.push({
                    pathname: ROUTES.FORM,
                    screenComming: 'coursesAndTraining',
                    selectedLine: element,
                  });
                }}
              >
                {I18n.t('edit')}
              </button>
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => {
                  this.setState({
                    selectedLine: { ...element },
                    showModal: true,
                    showCancel: true,
                    titleModal: I18n.t('delete'),
                    titleModalBody: I18n.t('canNotBeUndone'),
                  });
                }}
              >
                {I18n.t('delete')}
              </button>
            </div>
          </div>
        </div>
      ),
    }));

    this.setState({
      totalRecord: count,
      dataList,
    });
  }

  getListCoursesAndTraining = async () => {
    const {
      search, page, limit, orderBy = '', field = '',
    } = this.state;
    const skip = (page - 1) * limit;

    try {
      const { count = 0, rows = [] } = await this.props.getListCoursesAndTraining(
        limit, skip, search, orderBy, field,
      );

      await this.adjustData(count, rows);
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError,
        });
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch'),
        });
      }
    }
  }

  deleteCoursesAndTraining = async () => {
    this.setState({ showModal: false });
    try {
      await this.props.deleteCoursesAndTraining(this.state.selectedLine.id);
      await this.getListCoursesAndTraining();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError,
        });
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch'),
        });
      }
    }
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.getListCoursesAndTraining();
  }

  searchTable = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.getListCoursesAndTraining();
  }

  tableButtons = () => (
    <React.Fragment>
      <button
        onClick={() => history.push(ROUTES.UPLOAD_COURSES_AND_TRAINING)}
        type="button"
        className="btn btn-secondary margin-left-10"
      >
        {I18n.t('import')}
      </button>
    </React.Fragment>
  )

  render() {
    const {
      limit, page, dataList, totalRecord, titleModal, titleModalBody, showModal, showCancel,
    } = this.state;

    return (
      <div className="main-div-tables">

        <ModalComponent
          title={titleModal}
          showCancel={showCancel}
          body={titleModalBody}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('ok')}
          size={{ width: '350px', height: '200px' }}
          showButtons
          confirmModal={() => ((showCancel)
            ? this.deleteCoursesAndTraining()
            : this.setState({ showModal: false }))
          }
        />

        <Table
          title={I18n.t('coursesAndTraining')}
          buttons={this.tableButtons()}
          header={this.tableHeader}
          lines={dataList}
          page={page}
          perPage={limit}
          count={totalRecord || 0}
          searchItems={this.searchTable}
          showItemsCount
          sortTable={this.sortTable}
        />

      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getListCoursesAndTraining: (limit, skip, search, orderBy, field) => dispatch(
    getListCoursesAndTraining(limit, skip, search, orderBy, field),
  ),
  deleteCoursesAndTraining: coursesAndTrainingId => dispatch(
    deleteCoursesAndTraining(coursesAndTrainingId),
  ),
});

const mapStateToProps = (/* state */) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CoursesAndTrainingPage);
